import { render, staticRenderFns } from "./important_qr_list.vue?vue&type=template&id=54a17520&scoped=true&"
import script from "./important_qr_list.vue?vue&type=script&lang=js&"
export * from "./important_qr_list.vue?vue&type=script&lang=js&"
import style0 from "./important_qr_list.vue?vue&type=style&index=0&id=54a17520&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a17520",
  null
  
)

export default component.exports